const numberRegex = /%n/gi;
const pluralizeRegex = /{\s*(.+?)\s*:\s*(.+?)\s*}/gi;

export default function pluralize(count: number, templateString: string) {
  return templateString
    .replace(numberRegex, count.toString())
    .replace(pluralizeRegex, count === 1 ? '$1' : '$2');
}
